<div class="header-container">
	<h4 *ngIf="labelText">{{ labelText }}</h4>
	<span *ngIf="(uploadedFile$|async) && !readOnly" (click)="remove()">Remove</span>
</div>
<ng-container *ngIf="(uploadedFile$|async) === null; else hasImage">
	<ng-container *ngIf="!readOnly; else noImage">
		<div class="linq-file-upload">
			<sl-file-upload-dnd [label]="null" (filesSelected)="handleSelectedFiles($event)" [maxFiles]="1"
				[allowedExtensions]="imageExtensions"
				[helpText]="showAllowedExtensions ? allowedExtensionsMessage : ''"></sl-file-upload-dnd>
		</div>
	</ng-container>
	<ng-template #noImage>
		<div class="image-wrapper" [style.height.px]="heightProp">
			<div class="no-data-wrapper">
				<shared-no-data-available [message]="noDataMessage"></shared-no-data-available>
			</div>
		</div>
	</ng-template>
</ng-container>
<ng-template #hasImage>
	<ng-container *ngIf="(uploadedFile$|async) as file">
		<ng-container *ngIf="bindToUrl; else bindToFile">
			<div class="image-wrapper">
				<img [src]="sanitize(file.url)" alt="Image Preview" [style.height.px]="heightProp" />
			</div>
		</ng-container>
		<ng-template #bindToFile>
			<div class="image-wrapper">
				<img [src]="'data:image/jpeg;base64,' + file.fileBase64Encoded" [style.height.px]="heightProp" alt="Image Preview" />
			</div>
		</ng-template>
	</ng-container>
</ng-template>
